import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyFeedProduction } from "services";

import { FOOTPRINTING_DAIRY_FEED_PRODUCTION } from "consts";

export const useGetFootprintingDairyFeedProduction = (feedInformationId?: string) =>
  useQuery({
    queryKey: [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId],
    queryFn: () => getFootprintingDairyFeedProduction(feedInformationId ?? ""),
    enabled: !!feedInformationId,
    gcTime: 0,
  });
